export default __webpack_public_path__ + "static/media/Manrope-VariableFont_wght.fca742de.ttf";